export default __webpack_public_path__ + "static/media/AmpedUpEnterpriseImage.22d30902.png";